import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";
import api, { formatApiErrorDetail } from "../../lib/api";
import { DriverDashboard as DriverDashboardView } from "../../components/driver/DriverDashboard";

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export default function DriverDashboardPage() {
  const { user, ready, logout } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState({ current_job: null, next_job: null, today_jobs: [], upcoming_jobs: [] });

  const load = async () => {
    try {
      const { data } = await api.get("/driver/me/jobs");
      setData(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  if (ready && !user) return <Navigate to="/driver/login" replace />;
  if (ready && user?.role !== "driver") return <Navigate to="/admin" replace />;
  if (ready && user?.requires_password_change) return <Navigate to="/driver/set-password" replace />;

  const openJob = (job) => job && nav(`/driver/job/${job.id}`);
  const now = new Date();
  const todayStart = startOfDay(now);
  const tomorrowStart = new Date(todayStart); tomorrowStart.setDate(tomorrowStart.getDate() + 1);
  const dayAfterTomorrow = new Date(tomorrowStart); dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 1);
  const nextWeekEnd = new Date(todayStart); nextWeekEnd.setDate(nextWeekEnd.getDate() + 8);
  const incompleteToday = (data.today_jobs || []).filter((job) => !["completed", "cancelled"].includes(job.status));
  const tomorrowJobs = (data.upcoming_jobs || []).filter((job) => {
    const dt = new Date(job.planned_start_time);
    return dt >= tomorrowStart && dt < dayAfterTomorrow && !["completed", "cancelled"].includes(job.status);
  });
  const weekJobs = (data.upcoming_jobs || []).filter((job) => {
    const dt = new Date(job.planned_start_time);
    return dt >= dayAfterTomorrow && dt < nextWeekEnd && !["completed", "cancelled"].includes(job.status);
  });

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-5 sm:px-6" data-testid="driver-dashboard-page">
      <div className="mx-auto max-w-md">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-700">IceFleet Driver</p>
            <h1 className="mt-1 font-heading text-3xl font-semibold tracking-tight text-slate-900">Today’s tasks</h1>
          </div>
          <button type="button" onClick={logout} data-testid="driver-logout-button" className="rounded-xl border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-white">
            Logout
          </button>
        </div>
        <DriverDashboardView
          currentJob={data.current_job}
          nextJob={data.next_job}
          todayJobs={incompleteToday}
          tomorrowJobs={tomorrowJobs}
          weekJobs={weekJobs}
          onOpenJob={openJob}
          onPrimaryAction={openJob}
          onRefresh={load}
        />
      </div>
    </div>
  );
}